import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { AppVersionService } from '../../services/app-version.service';

@Component({
  selector: 'goatsports-new-version-banner',
  imports: [TranslocoDirective],
  templateUrl: './new-version-banner.component.html',
  styleUrls: ['./new-version-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewVersionBannerComponent {
  readonly service = inject(AppVersionService);
  private readonly transloco = inject(TranslocoService);

  reload(): void {
    const message = this.transloco.translate('Reload to load the latest version? Any unsaved changes will be lost.');
    if (window.confirm(message)) {
      window.location.reload();
    }
  }
}
